import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import Pagination from '../../../components/base/Pagination/Pagination';

export default function StopsList(props) {
  const {
    handleCreate = () => {},
    handleEdit = () => {},
    handleDelete = () => {},
    handleSelect = () => {},
    loadData = () => {},
    selected = null,
    stopsListMeta = {},
    stopsList = [],
    control,
  } = props;
  const { formatMessage } = useIntl();

  return (
    <div className="list-columns card py-3">
      <div className="list-header px-3">
        <div className="fs-5 fw-semibold ">{formatMessage({ id: 'menu.stops' })}</div>
        <Button className="small-button ms-2" variant="second" onClick={handleCreate}>
          <Icons customIcon icon="plus" />
        </Button>
      </div>
      <div className="filter-row px-3 mt-3">
        <FieldDTO
          control={control}
          component={TextInput}
          dtoObject={{
            name: 'search',
            type: String,
            labelKey: 'search',
          }}
          className="no-border"
          inputBefore={(
            <div className="search-wrapper">
              <Icons customIcon className="search" width={24} height={24} icon="search" />
            </div>
          )}
        />
      </div>
      <div className="list-content-wrapper">
        <div className="list-content-body custom-scroll-theme list-group list-group-flush border-bottom">
          {stopsList.map((stops, key) => (
            <div
              key={key}
              className={classNames('list-group-item list-group-item-action py-3 lh-sm pointer', { active: stops.stop_id === selected })}
              onClick={handleSelect(stops)}
            >
              <div className="d-flex w-100 align-items-center justify-content-between">
                <div className="d-flex flex-row col-xxl-12">
                  <div className="list-item-name"><strong className="mb-1">{stops?.name || ''}</strong></div>
                  <div className="stops-button-block d-flex flex-row ms-auto">
                    {/* <div className="stops-capacity"><small>{stops?.capacity || ''}</small></div> */}
                    <Button className="small-button ms-1" variant="second" onClick={handleEdit(stops)}>
                      <Icons icon="pencil" />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="w-100 mb-1 mt-1 small">{stops?.description || ''}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="list-footer px-3">
        <Pagination meta={stopsListMeta} list={stopsList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
